import { createStore } from 'vuex';
import app from './app';
// eslint-disable-next-line import/no-cycle
import user from './user';

const store = createStore({
  modules: {
    app,
    user,
  },
});

export default store;
